import { COLUMN_CARDS_COUNT, COLUMN_NAME } from "../../constants/column-types";
import { TableColumn } from "../table/TableColumn";

const CardTypeColumns : TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "trnName",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Cards",
        accessor: "cards",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "cards",
        columnId: COLUMN_CARDS_COUNT,
    },
];

export default CardTypeColumns;
